/**
 * Calculate dynamic size for use on grid with drawer
 * Set height equal to the available free space in the parent element
 * Also set width in table style. This is fix for some problem with grid on drawer,
 * on first load kendo insert width:0px in tables style.
 */
import React from 'react';

function withDynamicSize(WrappedComponent: any) {
  return class extends React.Component<any, {}> {
    innerRef: any;

    constructor(props: any) {
      super(props);
      this.innerRef = React.createRef();
    }

    /**
     * Set height and width on tables
     */
    setSize() {
      if (this.innerRef && this.innerRef.current) {
        const current = this.innerRef.current;
        const parent = current.parentElement;
        const child = current.firstElementChild;
        const columnsButtonGroupHeight: number = 26;
        let i = current.childElementCount;
        let childrenHeightSum = 0;
        while (i-- > 1) {
          childrenHeightSum += current.children[i].offsetHeight;
        }
        child.style.height = '0px';
        child.style.height = `${parent.offsetHeight - childrenHeightSum - columnsButtonGroupHeight}px`;

        let tables = current.getElementsByTagName('table');
        let tablesLength = tables.length;
        let currentTable: HTMLElement;
        let currentWidth: number;
        let headerTableWidth = tables[0].offsetWidth;
        while (tablesLength) {
          tablesLength--;
          currentTable = tables[tablesLength];
          currentWidth = currentTable.offsetWidth || headerTableWidth; // force width for empty grid, header table always have offsetWidth
          currentTable.style.width = `${currentWidth}px`;
        }
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          innerRef={this.innerRef}
          setDynamicSize={this.setSize}
        />
      );
    }
  };
}

export default withDynamicSize;
